import { render, staticRenderFns } from "./kilometer-course-card.vue?vue&type=template&id=1c3c0dbb&scoped=true"
import script from "./kilometer-course-card.vue?vue&type=script&lang=js"
export * from "./kilometer-course-card.vue?vue&type=script&lang=js"
import style0 from "./kilometer-course-card.vue?vue&type=style&index=0&id=1c3c0dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c0dbb",
  null
  
)

export default component.exports